import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IConsolidatedActivitiesByStudentFilters } from 'presentation/app/modules/Reports/models/consolidated-activities-by-student-filters';

interface IConsolidatedActivitiesByStudentState {
  filters: IConsolidatedActivitiesByStudentFilters;
}

interface IPayloadConsolidatedActivitiesByStudentFilters
  extends PayloadAction<IConsolidatedActivitiesByStudentFilters> {}

const initialState: IConsolidatedActivitiesByStudentState = {
  filters: null,
};

export const ConsolidatedActivitiesByStudentSlice = createSlice({
  name: 'consolidated-activities-by-student',
  initialState,
  reducers: {
    loadFilters: (
      state,
      action: IPayloadConsolidatedActivitiesByStudentFilters,
    ) => {
      state.filters = action.payload;
    },
    clearFilters: (state) => {
      state.filters = null;
    },
  },
});

export const { loadFilters, clearFilters } =
  ConsolidatedActivitiesByStudentSlice.actions;

export default ConsolidatedActivitiesByStudentSlice.reducer;
